module.exports = __webpack_public_path__ + "img/comedie_musical-jules_verne.267578d7.jpg";